class ImageZoom {
    constructor(elemId) {
        this.modal = document.querySelector("#" + elemId),
        this.initializedListeners = !1,
        this.offsetX = 0,
        this.offsetY = 0,
        this.scaleValue = 1,
        this.isDragging = !1,
        this.startX = 0,
        this.startY = 0,
        this.currentX = 0,
        this.currentY = 0,
        this.init()
    }
    init() {
        document.querySelectorAll(".product__modal-opener").forEach(opener => {
            opener.addEventListener("click", () => {
                this.openModal(opener)
            }
            );
            let img = new Image;
            img.src = opener.dataset.src,
            img = null
        }
        )
    }
    setImgSrc(src) {
        this.modalImage.src = src
    }
    openModal(opener) {
        this.modalImage = this.modal.querySelector(".modal-content img"),
        this.modal.style.display = "block",
        this.body = document.querySelector("body"),
        this.body.style.overflow = "hidden",
        this.zoom = this.modal.querySelector("input.zoom"),
        this.previous = opener.parentElement.previousElementSibling,
        this.next = opener.parentElement.nextElementSibling,
        this.imgContainer = this.modal.querySelector(".image-wrapper"),
        this.initializedListeners || this.addListeners(),
        this.setImgSrc(opener.dataset.src)
    }
    closeModal() {
        this.resetZoom(),
        this.modal.style.display = "none",
        this.body.style.overflow = ""
    }
    openNext() {
        this.next && (this.closeModal(),
        this.next.querySelector(".product__modal-opener").click())
    }
    openPrevious() {
        this.previous && (this.closeModal(),
        this.previous.querySelector(".product__modal-opener").click())
    }
    dragImage(event) {
        event.type === "touchmove" && (event.preventDefault(),
        event = event.touches[0]),
        this.isDragging && (this.offsetX = event.clientX - this.startX,
        this.offsetY = event.clientY - this.startY,
        this.calculateConstraints(),
        this.modalImage.style.transform = `scale(${this.scaleValue}) translate(${this.offsetX}px, ${this.offsetY}px)`)
    }
    startDrag(event) {
        event.type === "touchstart" && (event = event.touches[0]),
        this.isDragging = !0,
        this.startX = event.clientX - this.currentX,
        this.startY = event.clientY - this.currentY,
        this.modalImage.style.cursor = "grabbing"
    }
    endDrag() {
        this.isDragging = !1,
        this.modalImage.style.cursor = "grab"
    }
    calculateConstraints() {
        let maxOffsetX = (this.modalImage.clientWidth * this.scaleValue - this.imgContainer.clientWidth) / 2 / this.scaleValue
          , maxOffsetY = (this.modalImage.clientHeight * this.scaleValue - this.imgContainer.clientHeight) / 2 / this.scaleValue;
        this.offsetX > maxOffsetX && (this.offsetX = maxOffsetX),
        this.offsetX < -maxOffsetX && (this.offsetX = -maxOffsetX),
        this.offsetY > maxOffsetY && (this.offsetY = maxOffsetY),
        this.offsetY < -maxOffsetY && (this.offsetY = -maxOffsetY),
        this.currentX = this.offsetX,
        this.currentY = this.offsetY
    }
    addListeners() {
        this.modal.querySelector(".close").addEventListener("click", () => {
            this.closeModal()
        }
        ),
        this.modal.querySelector(".image-modal .modal-button.left button").addEventListener("click", this.openPrevious.bind(this)),
        this.modal.querySelector(".image-modal .modal-button.right button").addEventListener("click", this.openNext.bind(this)),
        this.zoom.addEventListener("input", event => {
            this.zoomImage(event.target.value)
        }
        ),
        this.modalImage.addEventListener("touchstart", this.startDrag.bind(this)),
        this.modalImage.addEventListener("mousedown", this.startDrag.bind(this)),
        window.addEventListener("mousemove", this.dragImage.bind(this)),
        window.addEventListener("touchmove", this.dragImage.bind(this)),
        window.addEventListener("mouseup", this.endDrag.bind(this)),
        window.addEventListener("touchend", this.endDrag.bind(this)),
        this.modalImage.addEventListener("dragstart", event => {
            event.preventDefault()
        }
        ),
        this.initializedListeners = !0
    }
    zoomImage(value) {
        this.scaleValue = value;
        var percentage = (value - this.zoom.min) / (this.zoom.max - this.zoom.min) * 100
          , adjustment = percentage > 50 ? -1 : 1;
        percentage = percentage + adjustment,
        this.zoom.style.background = `linear-gradient(to right, rgb(var(--secondary-color-pink)) 0%, rgb(var(--secondary-color-pink)) ${percentage}%, rgb(var(--primary-color-white)) ${percentage}%, rgb(var(--primary-color-white)) 100%)`,
        this.calculateConstraints(),
        this.modalImage.style.transform = `scale(${this.scaleValue}) translate(${this.offsetX}px, ${this.offsetY}px)`
    }
    resetZoom() {
        this.zoom.value = 1,
        this.zoomImage(1)
    }
}
//# sourceMappingURL=/cdn/shop/t/437/assets/image-zoom.js.map?v=59946896867642923571763476368
